import {Component, OnInit} from '@angular/core';
import {Constants} from "../../services/constants";
import {TenantService} from "../../services/tenant.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  content: any;
  tenantBucket = Constants.TENANT_BUCKET();

  constructor(private tenantService: TenantService) {
    this.tenantService.subscribeForTenant()
      .subscribe(tenant=> {
        this.loadDoc();
      });
  }

  ngOnInit() {
  }

  loadDoc() {
    let self = this;
    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        self.content = xhttp.responseText;
      }
    };
    xhttp.open("GET", this.tenantService.getFooterUrl(), true);
    xhttp.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhttp.send();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts